import { isBaseUrlString as m, isUrlString as S, toBaseUrlStringOrUndefined as v } from "@made-people/types-url-string";
import C from "axios";
import { getGearsServiceUrl as w, getGearsConfigurationVariable as b } from "@made-people/gears-configuration";
const x = 8e3;
class q {
  constructor(t) {
    if (this.options = t, !m(t.baseUrl))
      throw new Error(`${t.baseUrl} isn't a valid base URL`);
  }
  getXHeaders(t) {
    const e = {};
    for (const a of t.keys())
      if (/^x-forwarded-/i.test(a)) {
        const r = t.get(a);
        r && (e[a] = r);
      }
    return e;
  }
  /**
   * This method returns Response or undefined so the frontend
   * is forced to handle the absence of a response instead of
   * crashing due to a thrown error from a failing API request
   */
  async request(t, e, a = "get", r) {
    const i = [this.options.baseUrl, t].join("/");
    if (!S(i)) {
      console.error(`${i} isn't a valid URL string`);
      return;
    }
    const u = {};
    this.options.tenantId && (u["x-tenant-id"] = this.options.tenantId);
    const d = e.get("host");
    return d && (u["gears-host"] = d, e.get("x-forwarded-host") || e.set("x-forwarded-host", d)), [
      "cf-ipcountry",
      "cf-connecting-ip",
      "fastly-geoip-countrycode",
      "x-campaign-site-key"
    ].forEach((n) => {
      const c = e.get(n);
      c && (u[n] = c);
    }), C.request({
      url: i,
      method: a,
      data: r,
      headers: {
        ...u,
        ...this.getXHeaders(e)
      },
      validateStatus: function(n) {
        return n < 500;
      }
    }).then((n) => n.data).catch((n) => {
      var c, l, h, g, p, y;
      console.error({
        message: `Page lookup of ${i} failed`,
        request: {
          url: (c = n == null ? void 0 : n.config) == null ? void 0 : c.url,
          headers: (l = n == null ? void 0 : n.config) == null ? void 0 : l.headers,
          data: (h = n == null ? void 0 : n.config) == null ? void 0 : h.data
        },
        response: {
          status: (g = n == null ? void 0 : n.response) == null ? void 0 : g.status,
          headers: (p = n == null ? void 0 : n.response) == null ? void 0 : p.headers,
          data: (y = n == null ? void 0 : n.response) == null ? void 0 : y.data
        },
        error: {
          message: n == null ? void 0 : n.message,
          code: n == null ? void 0 : n.code,
          type: typeof n
        }
      });
    });
  }
  async initializeSelection(t, e) {
    const a = {
      ...t
    };
    a.campaignSite && delete a.campaignSite;
    const r = a;
    return this.request(
      `v1/centra/selection/${e ?? ""}?${new URLSearchParams(
        r
      )}`,
      new Headers(),
      "GET"
    );
  }
  async fetchFrontendProducts(t) {
    return this.request(
      "v1/centra/products-search",
      new Headers(),
      "POST",
      t
    );
  }
  async fetchFrontendProductsCached(t, e) {
    const a = new URLSearchParams({
      products: t.join(","),
      market: e.market,
      pricelist: e.pricelist,
      language: e.language
    });
    return this.request(
      `v1/centra/products-search?${a.toString()}`,
      new Headers(),
      "GET"
    );
  }
  async fetchProductWithSiblings(t) {
    const e = new URLSearchParams({
      productIds: t.productIds.join(","),
      market: t.frontendContext.market,
      pricelist: t.frontendContext.pricelist,
      language: t.frontendContext.language
    });
    return this.request(
      `v1/centra/product-with-siblings?${e.toString()}`,
      new Headers(),
      "GET"
    );
  }
  async findPage(t) {
    return this.request(
      ["v1/page", t.url.pathname, t.url.search].join(""),
      t.headers
    );
  }
  async findRobotsTxt(t) {
    return this.request(
      ["v1/google-sitemap/robots-txt"].join(""),
      t.headers
    );
  }
  async findSitemapIndex(t) {
    return this.request(
      ["v1/google-sitemap/index"].join(""),
      t.headers
    );
  }
  async findSitemap(t) {
    return this.request(
      [`v1/google-sitemap/${t.type}/${t.slug}`].join(""),
      t.headers
    );
  }
  async findSiteContent(t, e) {
    return this.request(
      `v1/site/settings-and-content/${t}`,
      e
    );
  }
  async findFrontendContextByCountryAndLanguageCode(t, e) {
    return this.request(
      `v1/site/frontend-context?countryCode=${t}&languageCode=${e}`,
      new Headers()
    );
  }
  async findAlternateLinkForSlug(t) {
    return this.request(
      `v1/page/find-alternate-link/${t.fullSlug}`,
      new Headers(),
      "POST",
      {
        target: t.targetFrontendContext
      }
    );
  }
  async fetchEcomIdToken(t) {
    const e = await this.request(
      "v1/ecomid/sessions",
      new Headers(),
      "POST",
      { ref_id: t }
    );
    return e == null ? void 0 : e.token;
  }
  async resolveStoryblokStory(t) {
    return this.request(
      `v1/page/storyblok-preview/resolve-story?${Object.entries(
        t.frontendContext
      ).map(([e, a]) => `${e}=${a}`).join("&")}`,
      new Headers(),
      "POST",
      t.story
    ).catch((e) => {
      console.log(e);
    });
  }
  async getUserMeta() {
    return this.request("v1/user-meta", new Headers());
  }
  async fetchAllocationRule(t, e) {
    const a = new URLSearchParams({ market: t });
    return e && a.set("country", e), this.request(
      `v1/centra/allocation-rule?${a.toString()}`,
      new Headers()
    );
  }
  async fetchReturnsLookup(t) {
    return this.request(
      "v1/returns/lookup",
      new Headers(),
      "POST",
      t
    );
  }
  async fetchTrustpilotProductReviews(t) {
    return this.request(
      "v1/trustpilot/product-reviews",
      new Headers(),
      "POST",
      t
    );
  }
  async fetchTrustpilotStoreReviews(t) {
    return this.request(
      "v1/trustpilot/store-reviews",
      new Headers(),
      "POST",
      t
    );
  }
  async fetchTrustpilotStoreSummary() {
    return this.request(
      "v1/trustpilot/store-summary",
      new Headers()
    );
  }
  async fetchTrustpilotProductSummary(t) {
    const e = `v1/trustpilot/product-summary?productSku=${encodeURIComponent(
      t.productSku
    )}`;
    return `${this.options.baseUrl}/${e}`.length <= x ? this.request(
      e,
      new Headers()
    ) : this.request(
      "v1/trustpilot/product-summary",
      new Headers(),
      "POST",
      t
    );
  }
}
let f;
function o() {
  const s = v(w("bff")), t = b("tenantId");
  if (typeof s > "u")
    throw new Error(
      `"${s}" isn't a valid base URL. Please make sure your environment variables are set correctly.`
    );
  return f || (f = new q({
    baseUrl: s,
    tenantId: t
  })), f;
}
const $ = async (s, t) => {
  const e = o();
  return s.pathname = s.pathname.replace(/^\/?/, "/"), e.findPage({
    url: s,
    headers: t
  }).catch((a) => {
  });
}, H = async (s) => o().fetchReturnsLookup(s).catch((e) => {
}), L = async (s) => o().findRobotsTxt({
  headers: s
}).catch((e) => {
}), R = async (s, t) => o().findSiteContent(s, t), I = async (s, t) => {
  const e = o(), [, , a, r] = s.pathname.split("/");
  if (!a || !r) {
    console.warn("Invalid sitemap url", s);
    return;
  }
  return e.findSitemap({
    type: a,
    slug: r,
    headers: t
  }).catch((i) => {
  });
}, F = async (s) => o().findSitemapIndex({
  headers: s
}).catch((e) => {
}), O = async () => o().getUserMeta().catch((t) => {
}), j = async (s) => {
  const t = o(), { fullSlug: e, targetFrontendContext: a } = s;
  return t.findAlternateLinkForSlug({
    fullSlug: e,
    targetFrontendContext: a
  });
}, A = async (s, t) => o().findFrontendContextByCountryAndLanguageCode(
  s,
  t
);
export {
  q as BffClient,
  $ as fetchPage,
  H as fetchReturnsLookup,
  L as fetchRobotsTxt,
  R as fetchSettingsAndContent,
  I as fetchSitemap,
  F as fetchSitemapIndex,
  O as fetchUserMeta,
  j as findAlternateLinkForSlug,
  A as findFrontendContextByCountryAndLanguageCode,
  o as getBffClient
};
//# sourceMappingURL=lib.es.js.map
